import React, { useMemo } from 'react'
import { Link } from 'gatsby'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components';


const getCoverLink = ({type, id, imageUrl}) => {
  const baseUrl = 'https://storage.googleapis.com/audiodesires-aab7f.appspot.com'
  if(type === "audiobook") return `${baseUrl}/audiobooks/${id}/artwork/200/200.webp`
  const fileName = imageUrl.split('/').pop().split('.')[0]
  if(type === "story") return `${baseUrl}/stories/${id}/artwork/200/${fileName}.webp`
  if(type === "sleep") return `${baseUrl}/sleep/${id}/artwork/200/${fileName}.webp`
  if(type === "community") return `${baseUrl}/communityStories/${id}/artwork/200/${fileName}.webp`
}

const getLink = ({type, story, t}) => {
  if(type === "sleep") return `${t('urls.sleep')}${story.slug}`
  if(type === "story") return `${t('urls.story')}${story.slug}`
  if(type === "community") return `${t('urls.community-story')}${story.slug}`
  if(type === "audiobook") return `${t('urls.audiobook')}${story.slug}`
}

const StoryItem = (props) => {
  const { t } = useTranslation()
  const {story, lazyLoadImg, margin} = props
  const { id, type, imageUrl, title, tags} = story
  const coverLink = useMemo(() => getCoverLink({type, id, imageUrl}), [type, id, imageUrl])
  const link = useMemo(() => getLink({type, story, t}), [type, story, t])

  return ( 
    <StyledLink to={link} key={id} $margin={margin}>
      <Wrapper>
        <CoverWrapper>
          <Cover src={coverLink}  alt={`${title} Erotic Audio Story Audiodesires`} loading={lazyLoadImg ? "lazy" : "eager"}/> 
          <MainFantasyLink to={`${type === "sleep" ? t('urls.sleep-tag') : t('urls.fantasy')}${tags[0].slug}`}>{`${type === "sleep" ? tags[0].tag : tags[0].fantasy}`}</MainFantasyLink>
        </CoverWrapper>
        <StorySliderItemMeta>
          <StoryTitleSmall>{title}</StoryTitleSmall>
           {tags.length > 1 && <TagLink to={`${type === "sleep" ? t('urls.sleep-tag') : t('urls.fantasy')}${tags[1].slug}`}>{`${type === "sleep" ? tags[1].tag : tags[1].fantasy},`}</TagLink>}
           {tags.length > 2 && <TagLink to={`${type === "sleep" ? t('urls.sleep-tag') : t('urls.fantasy')}${tags[2].slug}`}>{`${type === "sleep" ? tags[2].tag : tags[2].fantasy}`}</TagLink>}
        </StorySliderItemMeta>
      </Wrapper>
    </StyledLink>)
  
}

export default StoryItem

const StyledLink = styled(Link)`
  --item-size: min(200px, calc(50vw - 15px));
  text-decoration: none;
  display: block;
  max-width: var(--item-size);
  margin-right: ${props => props.$margin ? "10px" : "0px"};
  @media (max-width: 768px) {
    margin-right: ${props => props.$margin ? "0px" : "0px"};
    margin-left: ${props => props.$margin ? "10px" : "0px"};
  }
`;

const CoverWrapper = styled.div`
  position: relative;
  display: flex;
`;

const Cover = styled.img`
  height: var(--item-size);
  width: var(--item-size);
  border-radius: 5px;
`

const MainFantasyLink = styled(Link)`
  white-space: nowrap;
  position: absolute;
  height: 20px;
  background-color: #614848;
  color: white;
  font-family: 'Poppins';
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 25px;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  z-index: 1; 
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;

  @media (max-width: 480px) {
    font-size: 10px;
    padding: 3px 8px;
    height: 16px;
    line-height: 10px;
  }
`;

const Wrapper = styled.div``;

const StoryTitleSmall = styled.h3`
  margin: 0px 0px;
  font-size: 18px;
  font-family: 'Romana Becker Demi';
  display: block;
  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const StorySliderItemMeta = styled.div`
  margin-bottom: 0px;
`

const TagLink = styled(Link)`
  text-decoration: none;
  color: #A68C8A;
  font-size: 12px;
  font-family: 'Poppins';
  font-weight: 700;
  text-transform: uppercase;
  margin-right:5px;
`;